import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  packagingSubMenu,
  productSubMenu,
  rolesModuleName,
  superAdminRoleStr,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ProjectsFacade } from '@piqet-angular/data';
import {
  customEncode,
  getRolesAndPermission,
  getRolesAndPermissionForProject,
  abbreviateCountryStr,
} from 'libs/shared/src/lib/service/helper.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectsDataGridService {
  event: any;
  myAllProjectListPayload: any;
  Access: any;
  productProjectsPayload: any;

  deleteProject = new Subject<[any]>();
  deleteProjectData$ = this.deleteProject.asObservable();

  deleteProductProject = new Subject<[any]>();
  deleteProductProjectData$ = this.deleteProductProject.asObservable();

  deleteProductProjectDashboard = new Subject<[any]>();
  deleteProductProjectDashboard$ = this.deleteProductProjectDashboard.asObservable();

  copyProject = new Subject<[any, any]>();
  copyProjectData$ = this.copyProject.asObservable();

  hideUnhideSubject = new Subject<any>();
  hideUnhideSubject$ = this.hideUnhideSubject.asObservable();

  hideUnhideFunProduct = new Subject<any>();
  hideUnhideFunProduct$ = this.hideUnhideFunProduct.asObservable();

  hideUnhideSubjectDashboard = new Subject<any>();
  hideUnhideSubjectDashboard$ = this.hideUnhideSubjectDashboard.asObservable();

  copyProductConfiguration = new Subject<[any]>();
  copyProductConfigurationData$ = this.copyProductConfiguration.asObservable();

  constructor(
    private readonly projectFacde: ProjectsFacade,
    private readonly router: Router,
    private readonly swalService: SwalService,
    private readonly accessService: AccessPermissionService,
    private readonly sharedService: SharedService
  ) {}

  accessPermission(type?: string): boolean {
    let access = false;
    if (type) {
      access =
        this.accessService.hasPermission('edit', '', type) ||
        this.accessService.hasPermission('delete', '', type) ||
        this.accessService.hasPermission('create', '', type);
    } else {
      access =
        this.accessService.hasPermission('edit', '') ||
        this.accessService.hasPermission('delete', '') ||
        this.accessService.hasPermission('create', '');
    }
    return access;
  }

  getDashboardProjectsDataColumn(pathName: any, userRole?: string): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'ProjectName',
      headerName: 'Name',
      field: 'projectName',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridProjectLinkComponent',
      cellRendererParams: {
        projectName: 'dashboard',
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ProjectCode',
      headerName: 'Code',
      field: 'projectCode',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: function (param: any) {
        const data = param.data.projectCode.split('-');
        return data[0] + '<br/>' + data[1];
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ProjectType',
      headerName: 'Type',
      field: 'projectType',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Status',
      headerName: 'Status',
      field: 'status',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
      cellRenderer: 'inlineTooltipComponent',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OwnerName',
      headerName: 'Owner',
      field: 'ownerName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Share',
      headerName: 'Shared with',
      field: 'share',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      sortable: false,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'CountryName',
      headerName: 'Country',
      field: 'countryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      sortable: false,
      resizable: false,
      valueFormatter: (params: any) => abbreviateCountryStr(params.data?.countryName),
    });

    userRole == superAdminRoleStr &&
      colDef.push({
        ...defaultColumn,
        colId: 'LastModifiedDate',
        headerName: 'Last modified on',
        field: 'lastModifiedDate',
        cellClass: 'my-permission-cursor-pointer',
        wrapText: true,
        autoHeight: true,
        lockVisible: true,
        resizable: false,
      });

    (this.isDashboardAccess('edit') || this.isDashboardAccess('delete')) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'Actions',
        sortable: false,
        suppressMovable: true,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          from: 'dashBord',
          showHide: this.isDashboardAccess('create'),
          showEdit: this.isDashboardAccess('edit'),
          showCopy: this.isDashboardAccess('create'),
          showDelete: this.isDashboardAccess('delete'),
          deleteData: (data: any) => {
            if (data.projectType == 'Packaging project') {
              this.deleteConfirmation(data, false, true);
            } else {
              this.deleteConfirmation(data, true, true);
            }
          },
          copyData: (data: any) => {
            this.copyProject.next([data.projectId, 'Copy project']);
          },
          hideUnhideFun: (data: any) => {
            this.hideUnhideSubjectDashboard.next(data);
          },
          copyDataEditRendarar: (data: any) => {
            return false;
          },
          viewData: (data: any) => {
            data.projectType == 'Packaging project'
              ? this.router.navigate([
                  'projects/projects-setting',
                  customEncode(btoa(data.projectId)),
                  'setting',
                ])
              : this.router.navigate([
                  'projects/product-configuration/',
                  customEncode(btoa(data.projectId)),
                  'configuration',
                ]);
            localStorage.setItem('pCode', data.projectId);
          },
          editData: (data: any) => {
            data.projectType == 'Packaging project'
              ? this.router.navigate([
                  'projects/projects-setting',
                  customEncode(btoa(data.projectId)),
                  'setting',
                ])
              : this.router.navigate([
                  'projects/product-configuration/',
                  customEncode(btoa(data.projectId)),
                  'configuration',
                ]);
            localStorage.setItem('pCode', data.projectId);
          },
        },
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  getProjectsTabDataColumn(pathName: any, userRole?: string): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'ProjectImage',
      headerName: '',
      field: 'projectImage',
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xxm,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ProjectName',
      headerName: 'Name',
      field: 'projectName',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridProjectLinkComponent',
      cellRendererParams: {
        projectName: 'project',
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ProjectCode',
      headerName: 'Code',
      field: 'projectCode',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: function (param: any) {
        const data = param.data.projectCode.split('-');
        return data[0] + '<br/>' + data[1];
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Status',
      headerName: 'Status',
      field: 'status',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OwnerName',
      headerName: 'Owner',
      field: 'ownerName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TeamName',
      headerName: 'Team',
      field: 'teamName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });
    pathName == 'admin-projects' &&
      colDef.push({
        ...defaultColumn,
        colId: 'OragnizationName',
        headerName: 'Organization',
        field: 'oragnizationName',
        cellClass: 'my-permission-cursor-pointer',
        wrapText: true,
        autoHeight: true,
        lockVisible: true,
        resizable: false,
      });
    colDef.push({
      ...defaultColumn,
      colId: 'CountryName',
      headerName: 'Country',
      field: 'countryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      valueFormatter: (params: any) => abbreviateCountryStr(params.data?.countryName),
    });
    pathName == 'admin-projects' &&
      colDef.push({
        ...defaultColumn,
        colId: 'IsProjectVisible',
        headerName: 'Visible',
        field: 'isProjectVisible',
        cellClass: 'my-permission-cursor-pointer',
        wrapText: true,
        autoHeight: true,
        lockVisible: true,
        resizable: false,
        cellRenderer: (params: any) => {
          return `<span>${params.data.isProjectVisible ? 'Yes' : 'No'}</span>`;
        },
      });
    userRole == superAdminRoleStr &&
      colDef.push({
        ...defaultColumn,
        colId: 'LastModifiedDate',
        headerName: 'Last modified on',
        field: 'lastModifiedDate',
        cellClass: 'my-permission-cursor-pointer',
        wrapText: true,
        autoHeight: true,
        lockVisible: true,
        resizable: false,
      });
    this.accessPermission('packaging') &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'Actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showView:
            this.accessService.hasPermission('view', pathName, 'packaging') ||
            this.accessService.hasPermission('edit', pathName, 'packaging'),
          showCopy: this.accessService.hasPermission('create', pathName, 'packaging'),
          showDelete: this.accessService.hasPermission('delete', pathName, 'packaging'),
          showHide: this.accessService.hasPermission(pathName, 'packaging'),
          deleteData: (data: any) => {
            this.deleteConfirmation(data);
          },
          from: 'packagingGrid',
          copyData: (data: any) => {
            this.copyProject.next([data.projectId, 'Copy project']);
          },
          hideUnhideFun: (data: any) => {
            this.hideUnhideSubject.next(data);
          },
          copyDataEditRendarar: () => {
            return false;
          },
          viewData: (data: any) => {
            if (data.projectType == 'Product project') {
              this.router.navigate([
                `projects/product-configuration/${customEncode(
                  btoa(data?.productConfigId)
                )}/setting`,
              ]);
              localStorage.setItem('productConfigId', data?.productConfigId);
            } else {
              localStorage.setItem('pCode', data.projectId);
              this.router.navigate([
                'projects/projects-setting',
                customEncode(btoa(data.projectId)),
                'setting',
              ]);
            }
          },
        },
        lockVisible: true,
        resizable: false,
        lockPosition: right,
      });

    return colDef;
  }

  getProductProjectsTabDataColumn(pathName: any, userRole: string): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'ProductImage',
      headerName: '',
      field: 'productImage',
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xxm,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ProductName',
      headerName: 'Product name',
      field: 'productName',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridProjectLinkComponent',
      cellRendererParams: {
        projectName: 'productProject',
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'ProductCode',
      headerName: 'Product code',
      field: 'productCode',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: function (param: any) {
        const data = param.data.productCode.split('-');
        return data[0] + '<br/>' + data[1];
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Owner',
      headerName: 'Owner',
      field: 'owner',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });
    pathName == 'admin-projects' &&
      colDef.push({
        ...defaultColumn,
        colId: 'IsProjectVisible',
        headerName: 'Visible',
        field: 'isVisible',
        cellClass: 'my-permission-cursor-pointer',
        wrapText: true,
        autoHeight: true,
        lockVisible: true,
        resizable: false,
        cellRenderer: (params: any) => {
          return `<span>${params.data.isVisible ? 'Yes' : 'No'}</span>`;
        },
      });
    userRole == superAdminRoleStr &&
      colDef.push({
        ...defaultColumn,
        colId: 'modifiedOn',
        headerName: 'Last modified on',
        field: 'lastModifiedDate',
        cellClass: 'my-permission-cursor-pointer',
        wrapText: true,
        autoHeight: true,
        lockVisible: true,
        resizable: false,
      });
    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'Actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          // showView: this.isAccess(pathName) ? this.isAccess(pathName).isView || this.isAccess(pathName).isEdit : true,
          // showDelete: this.isAccess(pathName) ? this.isAccess(pathName).isDelete : true,
          // showHide: this.isAccess(pathName) ? this.isAccess(pathName).isCreate : true,

          showView:
            this.accessService.hasPermission('view', pathName) ||
            this.accessService.hasPermission('edit', pathName),
          showDelete: this.accessService.hasPermission('delete', pathName),
          showCopy: this.accessService.hasPermission('create', pathName),
          showHide: this.accessService.hasPermission(pathName),
          viewData: (data: any) => {
            const encodedValue = data.productConfigId;
            localStorage.setItem('productConfigId', encodedValue);
            this.router.navigate([
              `projects/product-configuration/${customEncode(btoa(encodedValue))}/setting`,
            ]);
            this.sharedService.scenarioNameFunc(data?.productName);
            localStorage.setItem('scenarioName', data?.productName);
          },
          hideUnhideFun: (data: any) => {
            this.hideUnhideFunProduct.next(data);
          },
          deleteData: (data: any) => {
            this.deleteConfirmation(data, true);
          },
          copyData: (data: any) => {
            this.copyProductConfiguration.next(data);
          },
          copyDataEditRendarar: (data: any) => {
            return false;
          },
        },
        lockVisible: true,
        resizable: false,
        lockPosition: right,
      });
    return colDef;
  }

  getNewDefaultSettingColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'Description',
      headerName: 'Material',
      field: 'description',
      maxWidth: grid_widths_map.lg_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'dropdownRendered',
      cellRendererParams: {
        from: 'myProject',
        editData: (data: any) => {
          this.projectFacde.newMyProjectAction(data, 'edit');
        },
      },
      wrapText: true,
      sortable: false,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Range',
      headerName: 'Range',
      field: 'range',
      cellRenderer: 'GridNewAddProjectSliderComponent',
      cellRendererParams: {
        from: 'range',
        sliderData: (data: any) => {
          this.projectFacde.newMyProjectAction(data, 'edit');
        },
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'Actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showDelete: true,
        deleteData: (data: any) => {
          this.alertConfirmation(data);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  alertConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectFacde.newMyProjectAction(data, 'delete');
      }
    });
  }

  deleteConfirmation(data: any, isProduct?: boolean, isDashboard?: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed && !isProduct && isDashboard) {
        this.deleteProject.next([data]);
      } else if (confirmed && !isProduct && !isDashboard) {
        this.deleteProject.next([data]);
      } else if (confirmed && isProduct && isDashboard) {
        this.deleteProductProjectDashboard.next([data]);
      } else if (confirmed && isProduct) {
        this.deleteProductProject.next([data]);
      } else {
      }
    });
  }

  isAccess = (pathName: any, type?: string) => {
    return pathName == 'admin-projects'
      ? getRolesAndPermission(
          rolesModuleName.AdministratorProjects,
          mainModuleName.projectManagementModule
        )
      : getRolesAndPermission(
          type ? rolesModuleName.packageScenario : rolesModuleName.productScenario,
          mainModuleName.projectsModule
        );
  };

  isDashboardAccess = (type: 'view' | 'edit' | 'create' | 'delete') => {
    return (
      this.accessService.hasModulePermission(
        rolesModuleName.packageScenario,
        mainModuleName.projectsModule,
        type
      ) &&
      this.accessService.hasModulePermission(
        rolesModuleName.productScenario,
        mainModuleName.productsModule,
        type
      )
    );
  };

  isProjectAccess = (pathName: any, subMenu: any) => {
    return pathName == 'admin-projects'
      ? getRolesAndPermission(
          rolesModuleName.AdministratorProjects,
          mainModuleName.projectManagementModule
        )
      : getRolesAndPermissionForProject(
          subMenu.toLowerCase() == packagingSubMenu
            ? rolesModuleName.packageScenario
            : rolesModuleName.productScenario,
          mainModuleName.projectsModule
        );
  };
}
